import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfService} from '../../conf.service';
import {MatSnackBar} from '@angular/material';
import {ConnecttocrudService} from '../../connecttocrud.service';
import * as CryptoJS from 'crypto-js';
import {environment} from '../../../environments/environment';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {KongService} from '../../kong.service';
import {Loggedin} from '../../authFilter/platformCentralAuth';
import {MatDialog} from '@angular/material/dialog';
import {error} from 'selenium-webdriver';

@Component({
    selector: 'app-user-verification',
    templateUrl: './user-verification.component.html',
    styleUrls: ['./user-verification.component.scss']
})
export class UserVerificationComponent implements OnInit {

    verified = false;
    password: any;
    cnfPassword: any;
    token: any;
    emailId: any;
    partner: any;
    username: any;
    expiry: any;
    shash: any;
    ralam: any;
    encyptedPassword: any;
    userDetail: any;
    consumerId: any;

    constructor(private Urlroute: ActivatedRoute, private confPost: ConfService, private kongService: KongService, private _snackBar: MatSnackBar, public dialog: MatDialog, public _service: ConnecttocrudService, public platform: LeftpanelComponent, public router: Router, public auth: Loggedin) {
    }

    ngOnInit() {
        this.auth.logoutWithoutReload();
        localStorage.setItem('domainPartner', 'services');
        this.Urlroute.queryParams
            .subscribe(params => {
                if (params.email && params.token && params.partner && params.username) {
                    this.token = params.token;
                    this.emailId = params.email;
                    this.partner = params.partner;
                    this.username = params.username;
                }

                this._service.getItemswithParameter('v1',  environment.accessPartner,  environment.accessPartner, 'users', 'user_token=' + this.token + '&email=' + this.emailId + '&expires_at.gte=' + Date.now() + '&status=' + false).subscribe(response => {
                    this.userDetail = response;
                    if (this.userDetail.length > 0) {
                        this.verified = false;
                    } else {
                        this.verified = true;
                    }
                });

            });

    }

    createUser() {
        if ((this.password === this.cnfPassword) && this.password !== '') {
            this.platform.passwordPolicyValidator(this.password).then(async status => {
                if (status) {
                    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                        maxWidth: '95vw',
                        maxHeight: '60vh',
                    });
                    this.encyrptUser(this.password);

                    this.verified = false;
                    const payload = {
                        'status': true
                    };
                    for (const e of this.userDetail[0]['environments']) {
                        const roleDetails = {
                            'role': e['name'] + '=>' + e['account'] + '=>' + this.emailId,
                            'permission_groups': [],
                            'permissions': [],
                            'roles': [],
                            'exclusions': [],
                            'partner': e['name'],
                            'account': e['account'],
                            'description': '',
                            'type': 'account'
                        };
                        const roleId = await this.createRoleForEachEnvironment(roleDetails);
                        e['password'] = this.encyptedPassword;
                        e['shash'] = this.shash;
                        e['ralam'] = this.ralam;
                        e['roles'] = [roleId];
                        e['audit_logs'].push(
                            {
                                action: 'UPDATE',
                                by: this.emailId,
                                at: Date.now()
                            }
                        );

                    }
                    const userDetail = {
                        environments: this.userDetail[0]['environments'],
                        status: true,
                        last_updated_at: Date.now(),
                        last_updated_by: this.emailId
                    };
                    this._service.patchItemUpdate(this.userDetail[0]['id'], userDetail, 'v1',  environment.accessPartner,  environment.accessPartner, 'users').subscribe( result => {
                        const temp = this.partner;
                        const consumerDetail = {
                            username: this.emailId,
                            custom_id: this.emailId,
                            tags: [temp]
                        };
                        this.kongService.createConsumerToKong(consumerDetail).subscribe(data => {
                            this.confPost.forgotEnvironment({email: this.emailId}).subscribe(resp => {
                                const responseMessage = resp['message'] ? resp['message'] : 'Your associated partner environments with apiplatform.io are successfully sent to your Email ID';
                                this.platform.openSnackBar(' Account created successfully' + '. '+ responseMessage, 'Success', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            }, error => {
                                this.platform.openSnackBar(' Account created successfully', 'Success', {
                                    duration: 2000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            });

                            this.kongService.postKongGatewayAPIkeyDetails(data['id'], {}, 'key-auth').subscribe(response => {
                                loaderDialog.close();
                                this.router.navigateByUrl('/auth/login');
                            });
                        }, error => {
                            if (error.status === 409) {
                                this.kongService.getKongGatewayConsumerDetails(this.emailId).subscribe(data => {
                                    const resposnse = data['data'][0];
                                    this.consumerId = resposnse['id'];
                                    let tags = resposnse['tags'];
                                    tags.push(this.partner);
                                    const patchPayload = {
                                        tags: tags
                                    };
                                    this.kongService.patchTagToConsumer(this.consumerId, patchPayload).subscribe((patchResult) => {
                                        this.confPost.forgotEnvironment({email: this.emailId}).subscribe(resp => {
                                            const responseMessage = resp['message'] ? resp['message'] : 'Your associated partner environments with apiplatform.io are successfully sent to your Email ID';

                                            this.platform.openSnackBar(' Account created successfully' + '. ' + responseMessage, 'Success', {
                                                duration: 5000,
                                                verticalPosition: 'top',
                                                horizontalPosition: 'center'
                                            });
                                        }, error => {
                                            this.platform.openSnackBar(' Account created successfully', 'Success', {
                                                duration: 2000,
                                                verticalPosition: 'top',
                                                horizontalPosition: 'center'
                                            });
                                        });

                                        loaderDialog.close();
                                        this.router.navigateByUrl('/auth/login');
                                    });
                                }, e => {
                                    if (e.status === 400) {
                                        loaderDialog.close();
                                        this.router.navigateByUrl('/auth/login');
                                    }
                                });
                            }
                        });
                    }, e => {
                    });
                } else {
                    this.platform.openSnackBar(' Please make sure that your password follows our password policy ', 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            });
        } else {
            this.platform.openSnackBar(' Passwords do not match ', 'Error', {
                duration: 2000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    createRoleForEachEnvironment(roleDetail) {
        return new Promise((resolve, reject) => {
            this._service.addItem(roleDetail, 'v1',  environment.accessPartner,  environment.accessPartner, 'roles').subscribe(data => {
                if (data) {
                    resolve(data['upsertedId']);
                } else {
                    resolve('failed');
                }
            }, error => {
                this.platform.notifyErrorToAdmins({error: 'Error occurred while creating role for the user ' + roleDetail['role']}, 'role_create_success', 'role_create_failed', 'Error occurred while creating role for the user ' + roleDetail['role'], roleDetail);
                resolve('failed');
            });
        });
    }

    encyrptUser(password) {
        const iterationCount = 1000;
        let keySize = 128;
        keySize = keySize / 32;
        const passphrase = environment.cipheringPhrase;
        const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
        const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
        const cipherText = this.platform.encrypt(salt, iv, passphrase, this.password, keySize, iterationCount);
        this.shash = salt;
        this.ralam = iv;
        this.encyptedPassword = cipherText;
    }


}
